import { createRouter, createWebHashHistory } from 'vue-router';
import CalendarPage from '../pages/calendar-page.vue';
import ReservationForm from '../components/reservation-form.vue';
import ReservationDetail from '../components/reservation-detail.vue';
import PendingChallenges from '../components/pending-challenges.vue';
import InactiveReservations from '../components/inactive-reservations.vue';
import TransferDetail from '../components/transfer-detail.vue';

const routes = [
  {
    path: '/',
    component: CalendarPage,
    props: true,
    children: [
      {
        path: '/new',
        component: ReservationForm,
      },
      {
        path: '/reservation/:id',
        component: ReservationDetail,
      },
      {
        path: '/pendings',
        component: PendingChallenges,
      },
      {
        path: '/inactives/:day',
        component: InactiveReservations,
      },
      {
        path: '/transfer/:id',
        component: TransferDetail,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
export default router;
